import React from 'react';
// CONTEXT
import { useTheme } from 'context/ThemeContext';

// IMAGES
import LogoLight from 'assets/images/Logo_AI_RVB_Couleur.png';
import LogoDark from 'assets/images/Logo_AI_RVB_Couleur_Blanc.png';
import LogoMobile from 'assets/images/Pastille_AI_RVB_Orange.png';

const Logo = ({ handleLogoClick }) => {
  const { theme } = useTheme();

  return (
    <div className="flex-shrink-0 flex items-center space-x-2 cursor-pointer transition-transform duration-200 ease-in-out transform hover:scale-105" onClick={handleLogoClick}>
      {theme === 'dark' ? (
        <img src={LogoDark} alt="altitudeInfra Logo" className="hidden lg:block h-12" />
      ) : (
        <img src={LogoLight} alt="altitudeInfra Logo" className="hidden lg:block h-12" />
      )}
      <img src={LogoMobile} alt="altitudeInfra Logo Mobile" className="block lg:hidden h-12" />
    </div>
  );
};

export default Logo;